import { render, staticRenderFns } from "./ContentReport.vue?vue&type=template&id=40c2c8d0&scoped=true&"
import script from "./ContentReport.vue?vue&type=script&lang=js&"
export * from "./ContentReport.vue?vue&type=script&lang=js&"
import style0 from "./ContentReport.vue?vue&type=style&index=0&id=40c2c8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2c8d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VContainer,VSelect,VTab,VTabItem,VTabs,VTabsSlider})
